<template>
  <div class="page">
    <div class="page-bar">
      <el-pagination
        :current-page='currentPage'
        background
        layout="prev, pager, next"
         :page-size="pageSize"
        @current-change="handleChange"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  export default {
    name:'page',
    props:{
      total:{
        type:Number,
        required:true,
        default:0
      },
      pageSize:{
        type:Number,
        required:true,
        default:0
      },
      currentPage:{
        type:Number,
        required:true,
        default:0
      }
    },
    data(){
      return {


      }
    },
    mounted(){

    },
    methods:{
      handleChange(res){
        this.$emit('pageNum',res)
      }
    },
    computed:{

    },
    watch:{

    }
  }
</script>

<style scoped>
  .page-bar {margin-top:30px;margin-bottom:40px;text-align: center;}
  .page-bar li {display:inline-block;margin-left:2px;margin-right:2px;}
  .page-bar a {padding:5px 10px;border:#ddd 1px solid;border-radius:4px;cursor: pointer;}
  .page-bar li.active a {color:#fff;border:#357af1 1px solid;background:#357af1;}
</style>



// WEBPACK FOOTER //
// src/components/Page.vue